import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    xxl: true; // NEW
  }
}

const lightTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#FAFAFA",
    },
    background: {
      paper: "#FFFFFF",
    },
    text: {
      primary: "#101828",
      secondary: "#4A5565",
    },
    grey: { 100: "#8D8D8D" },
  },
  typography: {
    fontFamily: "Inter",
    h1: { fontSize: "42px", fontWeight: 700 },
    h2: { fontSize: "36px", fontWeight: 700 },
    h3: {
      fontSize: "20px",
      fontWeight: 400,
    },
    h5: {
      fontSize: "18px",
      fontWeight: 700,
    },
    h6: {
      fontSize: "18px",
      fontWeight: 500,
    },

    subtitle1: {
      fontSize: "20px",
      fontWeight: 600,
    },
    body1: {
      fontSize: "16px",
      fontWeight: 400,
    },
  },
});

export default lightTheme;
